const t = (s, e) => {
  if (e) {
    if (e.message && typeof e.message == "string")
      return e.message;
    switch (e.type) {
      case "required":
        return s("INPUT_FIELD_REQUIRED");
      default:
        return s("INPUT_FIELD_FALLBACK_ERROR_MESSAGE");
    }
  }
};
export {
  t as getErrorMessage
};
